import Evidence from 'actions/evidence';

export default Evidence.createReducer();